var _defs, _g, _path, _path2, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppliaMembersManufacturingSitesInEurope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192.12 222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        clip-path: url(#clippath-6);\n      }\n\n      .st1 {\n        clip-path: url(#clippath-7);\n      }\n\n      .st2 {\n        clip-path: url(#clippath-17);\n      }\n\n      .st3 {\n        stroke: #333;\n        stroke-opacity: 0;\n      }\n\n      .st3, .st4, .st5 {\n        fill: none;\n      }\n\n      .st3, .st5 {\n        stroke-width: .56px;\n      }\n\n      .st6 {\n        clip-path: url(#clippath-15);\n      }\n\n      .st7 {\n        clip-path: url(#clippath-18);\n      }\n\n      .st8 {\n        clip-path: url(#clippath-4);\n      }\n\n      .st9 {\n        clip-path: url(#clippath-9);\n      }\n\n      .st10 {\n        clip-path: url(#clippath-10);\n      }\n\n      .st11 {\n        clip-path: url(#clippath-11);\n      }\n\n      .st12 {\n        clip-path: url(#clippath-1);\n      }\n\n      .st13 {\n        isolation: isolate;\n      }\n\n      .st14 {\n        clip-path: url(#clippath-5);\n      }\n\n      .st15 {\n        clip-path: url(#clippath-8);\n      }\n\n      .st16 {\n        clip-path: url(#clippath-3);\n      }\n\n      .st17 {\n        clip-path: url(#clippath-12);\n      }\n\n      .st18 {\n        clip-path: url(#clippath-14);\n      }\n\n      .st5 {\n        stroke: #000;\n      }\n\n      .st19 {\n        clip-path: url(#clippath-16);\n      }\n\n      .st20 {\n        clip-path: url(#clippath-2);\n      }\n\n      .st21 {\n        clip-path: url(#clippath-13);\n      }\n\n      .st22 {\n        fill: #0047ba;\n      }\n\n      .st23 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 67.71,
    y: 2.32,
    width: 121.49,
    height: 8.11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 67.71,
    y: 13.9,
    width: 121.49,
    height: 8.11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 67.71,
    y: 25.48,
    width: 102.31,
    height: 8.11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 67.71,
    y: 37.07,
    width: 89.52,
    height: 8.11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 67.71,
    y: 48.65,
    width: 76.73,
    height: 8.11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 67.71,
    y: 60.23,
    width: 57.55,
    height: 8.11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 67.71,
    y: 71.82,
    width: 31.97,
    height: 8.11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 67.71,
    y: 83.4,
    width: 31.97,
    height: 8.11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 67.71,
    y: 94.98,
    width: 25.58,
    height: 8.11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 67.71,
    y: 106.57,
    width: 19.18,
    height: 8.11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 67.71,
    y: 118.15,
    width: 12.79,
    height: 8.11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 67.71,
    y: 129.73,
    width: 12.79,
    height: 8.11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 67.71,
    y: 141.31,
    width: 12.79,
    height: 8.11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 67.71,
    y: 152.9,
    width: 12.79,
    height: 8.11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 67.71,
    y: 164.48,
    width: 6.39,
    height: 8.11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 67.71,
    y: 176.06,
    width: 6.39,
    height: 8.11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 67.71,
    y: 187.65,
    width: 6.39,
    height: 8.11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 67.71,
    y: 199.23,
    width: 6.39,
    height: 8.11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 67.71,
    y: 210.81,
    width: 6.39,
    height: 8.11
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M67.71,2.32h121.49v8.11h-121.49V2.32Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.71,2.32h121.49v8.11h-121.49V2.32Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M67.71,13.9h121.49v8.11h-121.49v-8.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.71,13.9h121.49v8.11h-121.49v-8.11Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M67.71,25.48h102.31v8.11h-102.31v-8.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.71,25.48h102.31v8.11h-102.31v-8.11Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M67.71,37.07h89.52v8.11h-89.52v-8.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.71,37.07h89.52v8.11h-89.52v-8.11Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M67.71,48.65h76.73v8.11h-76.73v-8.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.71,48.65h76.73v8.11h-76.73v-8.11Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M67.71,60.23h57.55v8.11h-57.55v-8.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.71,60.23h57.55v8.11h-57.55v-8.11Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M67.71,71.82h31.97v8.11h-31.97v-8.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.71,71.82h31.97v8.11h-31.97v-8.11Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M67.71,83.4h31.97v8.11h-31.97v-8.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.71,83.4h31.97v8.11h-31.97v-8.11Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M67.71,94.98h25.58v8.11h-25.58v-8.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.71,94.98h25.58v8.11h-25.58v-8.11Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M67.71,106.57h19.18v8.11h-19.18v-8.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.71,106.57h19.18v8.11h-19.18v-8.11Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M67.71,118.15h12.79v8.11h-12.79v-8.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.71,118.15h12.79v8.11h-12.79v-8.11Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M67.71,129.73h12.79v8.11h-12.79v-8.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.71,129.73h12.79v8.11h-12.79v-8.11Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M67.71,141.31h12.79v8.11h-12.79v-8.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.71,141.31h12.79v8.11h-12.79v-8.11Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M67.71,152.9h12.79v8.11h-12.79v-8.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.71,152.9h12.79v8.11h-12.79v-8.11Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M67.71,164.48h6.39v8.11h-6.39v-8.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.71,164.48h6.39v8.11h-6.39v-8.11Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M67.71,176.06h6.39v8.11h-6.39v-8.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.71,176.06h6.39v8.11h-6.39v-8.11Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M67.71,187.65h6.39v8.11h-6.39v-8.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.71,187.65h6.39v8.11h-6.39v-8.11Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M67.71,199.23h6.39v8.11h-6.39v-8.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.71,199.23h6.39v8.11h-6.39v-8.11Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M67.71,210.81h6.39v8.11h-6.39v-8.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.71,210.81h6.39v8.11h-6.39v-8.11Z"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M67.43,221.24h121.77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M67.71,0v221.24"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.21,3.02h1.77c1.39,0,2.34.46,2.34,1.83s-.94,1.92-2.3,1.92h-1.01v2.46h-.8V3.02ZM22.93,6.13c1.08,0,1.6-.4,1.6-1.28s-.55-1.18-1.64-1.18h-.88v2.46h.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.94,6.95c0-1.54,1-2.43,2.13-2.43s2.14.88,2.14,2.43-1.01,2.41-2.14,2.41-2.13-.88-2.13-2.41ZM29.4,6.95c0-1.06-.53-1.77-1.33-1.77s-1.32.71-1.32,1.77.53,1.75,1.32,1.75,1.33-.7,1.33-1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.42,8.31V2.49h.79v5.88c0,.25.1.33.23.33.05,0,.08,0,.16-.02l.1.59c-.11.06-.26.09-.45.09-.59,0-.82-.38-.82-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.55,8.04c0-1.02.85-1.52,2.82-1.73,0-.58-.2-1.14-.95-1.14-.53,0-1.01.24-1.37.47l-.3-.53c.43-.28,1.07-.6,1.81-.6,1.12,0,1.6.75,1.6,1.89v2.83h-.64l-.08-.55h-.03c-.44.37-.94.66-1.52.66-.77,0-1.35-.47-1.35-1.31ZM36.38,8.12v-1.25c-1.55.18-2.06.53-2.06,1.13,0,.51.35.71.8.71s.81-.2,1.26-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.61,4.63h.64l.07.66h.03c.44-.44.91-.78,1.54-.78.98,0,1.41.63,1.41,1.8v2.92h-.79v-2.81c0-.86-.27-1.22-.87-1.22-.46,0-.8.24-1.25.7v3.34h-.79v-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.47,6.95c0-1.5.95-2.43,2-2.43.53,0,.88.2,1.29.53l-.04-.79v-1.77h.79v6.75h-.64l-.07-.54h-.03c-.36.35-.85.65-1.39.65-1.16,0-1.9-.87-1.9-2.41ZM46.72,8.06v-2.41c-.39-.35-.74-.47-1.12-.47-.73,0-1.32.7-1.32,1.75s.46,1.75,1.26,1.75c.43,0,.8-.21,1.17-.62Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gtext1",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.85,17.71c0-2,1.2-3.22,2.85-3.22.86,0,1.43.38,1.79.77l-.44.49c-.31-.32-.71-.56-1.34-.56-1.25,0-2.05.96-2.05,2.5s.73,2.54,2.06,2.54c.45,0,.87-.13,1.12-.36v-1.62h-1.32v-.65h2.05v2.62c-.41.42-1.09.72-1.92.72-1.64,0-2.8-1.19-2.8-3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.64,18.52c0-1.5,1.01-2.42,2.07-2.42,1.18,0,1.85.83,1.85,2.16,0,.17,0,.31-.04.46h-3.1c.07.95.64,1.57,1.52,1.57.45,0,.83-.12,1.16-.34l.27.5c-.4.28-.89.47-1.53.47-1.23,0-2.2-.89-2.2-2.42ZM20.86,18.12c0-.91-.43-1.39-1.13-1.39-.64,0-1.21.51-1.31,1.39h2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.69,16.22h.64l.07.83h.03c.32-.58.8-.95,1.31-.95.21,0,.35.03.49.09l-.17.67c-.13-.04-.24-.06-.42-.06-.39,0-.85.27-1.17,1.05v2.96h-.79v-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.98,16.22h.64l.07.66h.03c.41-.44.88-.78,1.43-.78.71,0,1.09.33,1.28.87.47-.51.96-.87,1.52-.87.95,0,1.4.63,1.4,1.8v2.92h-.79v-2.81c0-.86-.27-1.22-.85-1.22-.36,0-.73.23-1.16.7v3.34h-.79v-2.81c0-.86-.27-1.22-.85-1.22-.34,0-.72.23-1.15.7v3.34h-.79v-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.56,19.63c0-1.02.85-1.52,2.82-1.73,0-.58-.2-1.14-.95-1.14-.53,0-1.01.24-1.37.47l-.3-.53c.43-.28,1.07-.6,1.81-.6,1.12,0,1.6.75,1.6,1.89v2.83h-.64l-.08-.55h-.03c-.44.37-.94.66-1.52.66-.77,0-1.35-.47-1.35-1.31ZM36.38,19.7v-1.25c-1.55.18-2.06.53-2.06,1.13,0,.51.35.71.8.71s.81-.2,1.26-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.62,16.22h.64l.07.66h.03c.44-.44.91-.78,1.54-.78.98,0,1.41.63,1.41,1.8v2.92h-.79v-2.81c0-.86-.27-1.22-.87-1.22-.46,0-.8.24-1.25.7v3.34h-.79v-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.34,22.71l.17-.62c.11.04.23.06.34.06.51,0,.84-.41,1.03-.98l.1-.34-1.85-4.61h.81l.93,2.54c.15.4.3.87.45,1.3h.04c.12-.42.26-.89.38-1.3l.82-2.54h.77l-1.73,4.98c-.32.91-.81,1.6-1.72,1.6-.22,0-.4-.04-.55-.09Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gtext2",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.17,26.19h.8v6.22h-.8v-6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.72,30.97v-2.54h-.68v-.59l.72-.05.09-1.48h.65v1.48h1.25v.63h-1.25v2.56c0,.56.19.88.71.88.17,0,.34-.03.53-.11l.16.56c-.25.11-.56.2-.87.2-.99,0-1.32-.63-1.32-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.32,31.21c0-1.02.85-1.52,2.82-1.73,0-.58-.2-1.14-.95-1.14-.53,0-1.01.24-1.37.47l-.3-.53c.43-.28,1.07-.6,1.81-.6,1.12,0,1.6.75,1.6,1.89v2.83h-.64l-.08-.55h-.03c-.44.37-.94.66-1.52.66-.77,0-1.35-.47-1.35-1.31ZM39.14,31.29v-1.25c-1.55.18-2.06.53-2.06,1.13,0,.51.35.71.8.71s.81-.2,1.26-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.38,31.48v-5.82h.79v5.88c0,.25.1.33.23.33.05,0,.08,0,.16-.02l.1.59c-.11.06-.26.09-.45.09-.59,0-.82-.38-.82-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.33,34.29l.17-.62c.11.04.23.06.34.06.51,0,.84-.41,1.03-.98l.1-.34-1.85-4.61h.81l.93,2.54c.15.4.3.87.45,1.3h.04c.12-.42.26-.89.38-1.3l.82-2.54h.77l-1.73,4.98c-.32.91-.81,1.6-1.72,1.6-.22,0-.4-.04-.55-.09Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gtext3",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.22,37.77h3.58v.67h-2.79v2.09h2.37v.67h-2.37v2.78h-.8v-6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.64,39.38h.64l.07.83h.03c.32-.58.8-.95,1.31-.95.21,0,.35.03.49.09l-.17.67c-.13-.04-.24-.06-.42-.06-.39,0-.85.27-1.17,1.05v2.96h-.79v-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.43,42.79c0-1.02.85-1.52,2.82-1.73,0-.58-.2-1.14-.95-1.14-.53,0-1.01.24-1.37.47l-.3-.53c.43-.28,1.07-.6,1.81-.6,1.12,0,1.6.75,1.6,1.89v2.83h-.64l-.08-.55h-.03c-.44.37-.94.66-1.52.66-.77,0-1.35-.47-1.35-1.31ZM32.25,42.87v-1.25c-1.55.18-2.06.53-2.06,1.13,0,.51.35.71.8.71s.81-.2,1.26-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.49,39.38h.64l.07.66h.03c.44-.44.91-.78,1.54-.78.98,0,1.41.63,1.41,1.8v2.92h-.79v-2.81c0-.86-.27-1.22-.87-1.22-.46,0-.8.24-1.25.7v3.34h-.79v-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.33,41.69c0-1.54,1.03-2.43,2.22-2.43.61,0,1.02.24,1.35.54l-.39.49c-.26-.24-.55-.38-.92-.38-.83,0-1.44.71-1.44,1.77s.57,1.75,1.41,1.75c.43,0,.81-.19,1.08-.44l.34.5c-.42.38-.94.59-1.49.59-1.22,0-2.16-.88-2.16-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.46,41.68c0-1.5,1.01-2.42,2.07-2.42,1.18,0,1.85.83,1.85,2.16,0,.17,0,.31-.04.46h-3.1c.07.95.64,1.57,1.52,1.57.45,0,.83-.12,1.16-.34l.27.5c-.4.28-.89.47-1.53.47-1.23,0-2.2-.89-2.2-2.42ZM46.67,41.29c0-.91-.43-1.39-1.13-1.39-.64,0-1.21.51-1.31,1.39h2.44Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gtext4",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.64,50.03h-1.88v-.67h4.56v.67h-1.89v5.54h-.8v-5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.85,53.88v-2.92h.79v2.81c0,.85.27,1.22.87,1.22.46,0,.8-.24,1.22-.78v-3.26h.79v4.6h-.64l-.07-.72h-.03c-.43.5-.88.83-1.52.83-.98,0-1.41-.63-1.41-1.8ZM24.32,49.53c0-.27.2-.47.47-.47s.46.21.46.47-.2.47-.46.47-.47-.21-.47-.47ZM26.15,49.53c0-.27.2-.47.46-.47s.47.21.47.47-.2.47-.47.47-.46-.21-.46-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.07,50.97h.64l.07.83h.03c.32-.58.8-.95,1.31-.95.21,0,.35.03.49.09l-.17.67c-.13-.04-.24-.06-.42-.06-.39,0-.85.27-1.17,1.05v2.96h-.79v-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.37,48.82h.78v4.55h.03l1.94-2.41h.88l-1.54,1.86,1.73,2.75h-.85l-1.35-2.21-.85,1v1.21h-.78v-6.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.94,49.51c0-.3.22-.51.52-.51s.52.21.52.51-.22.51-.52.51-.52-.2-.52-.51ZM37.06,50.97h.79v4.6h-.79v-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.94,57.46l.17-.62c.11.04.23.06.34.06.51,0,.84-.41,1.03-.98l.1-.34-1.85-4.61h.81l.93,2.54c.15.4.3.87.45,1.3h.04c.12-.42.26-.89.38-1.3l.82-2.54h.77l-1.73,4.98c-.32.91-.81,1.6-1.72,1.6-.22,0-.4-.04-.55-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.46,53.27c0-1.5,1.01-2.42,2.07-2.42,1.18,0,1.85.83,1.85,2.16,0,.17,0,.31-.04.46h-3.1c.07.95.64,1.57,1.52,1.57.45,0,.83-.12,1.16-.34l.27.5c-.4.28-.89.47-1.53.47-1.23,0-2.2-.89-2.2-2.42ZM46.67,52.87c0-.91-.43-1.39-1.13-1.39-.64,0-1.21.51-1.31,1.39h2.44Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gtext5",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.91,60.94h1.94c1.27,0,2.18.46,2.18,1.75,0,.97-.55,1.53-1.39,1.75l1.58,2.71h-.9l-1.5-2.62h-1.12v2.62h-.8v-6.22ZM15.74,63.88c.97,0,1.5-.4,1.5-1.19s-.53-1.11-1.5-1.11h-1.03v2.3h1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8,64.86c0-1.54,1-2.43,2.13-2.43s2.14.88,2.14,2.43-1.01,2.41-2.14,2.41-2.13-.88-2.13-2.41ZM22.26,64.86c0-1.06-.53-1.77-1.33-1.77s-1.32.71-1.32,1.77.53,1.75,1.32,1.75,1.33-.7,1.33-1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.28,62.55h.64l.07.66h.03c.41-.44.88-.78,1.43-.78.71,0,1.09.33,1.28.87.47-.51.96-.87,1.52-.87.95,0,1.4.63,1.4,1.8v2.92h-.79v-2.81c0-.86-.27-1.22-.85-1.22-.36,0-.73.23-1.16.7v3.34h-.79v-2.81c0-.86-.27-1.22-.85-1.22-.34,0-.72.23-1.15.7v3.34h-.79v-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.85,65.96c0-1.02.85-1.52,2.82-1.73,0-.58-.2-1.14-.95-1.14-.53,0-1.01.24-1.37.47l-.3-.53c.43-.28,1.07-.6,1.81-.6,1.12,0,1.6.75,1.6,1.89v2.83h-.64l-.08-.55h-.03c-.44.37-.94.66-1.52.66-.77,0-1.35-.47-1.35-1.31ZM34.68,66.04v-1.25c-1.55.18-2.06.53-2.06,1.13,0,.51.35.71.8.71s.81-.2,1.26-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.91,62.55h.64l.07.66h.03c.44-.44.91-.78,1.54-.78.98,0,1.41.63,1.41,1.8v2.92h-.79v-2.81c0-.86-.27-1.22-.87-1.22-.46,0-.8.24-1.25.7v3.34h-.79v-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.97,61.09c0-.3.22-.51.52-.51s.52.21.52.51-.22.51-.52.51-.52-.2-.52-.51ZM42.1,62.55h.79v4.6h-.79v-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.15,65.96c0-1.02.85-1.52,2.82-1.73,0-.58-.2-1.14-.95-1.14-.53,0-1.01.24-1.37.47l-.3-.53c.43-.28,1.07-.6,1.81-.6,1.12,0,1.6.75,1.6,1.89v2.83h-.64l-.08-.55h-.03c-.44.37-.94.66-1.52.66-.77,0-1.35-.47-1.35-1.31ZM46.98,66.04v-1.25c-1.55.18-2.06.53-2.06,1.13,0,.51.35.71.8.71s.81-.2,1.26-.59Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gtext6",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.11,77.92l.45-.52c.46.46,1.09.75,1.74.75.81,0,1.3-.41,1.3-1,0-.63-.46-.83-1.03-1.09l-.9-.4c-.58-.25-1.25-.68-1.25-1.6s.82-1.65,1.95-1.65c.76,0,1.4.31,1.84.75l-.44.53c-.38-.36-.86-.58-1.4-.58-.69,0-1.15.35-1.15.9,0,.6.54.82,1.02,1.02l.89.39c.72.3,1.28.74,1.28,1.66,0,.99-.81,1.77-2.12,1.77-.89,0-1.64-.35-2.18-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.55,74.13h.64l.07.53h.03c.42-.35.94-.64,1.47-.64,1.18,0,1.83.92,1.83,2.35,0,1.56-.95,2.48-2,2.48-.42,0-.85-.2-1.27-.53l.02.81v1.55h-.79v-6.55ZM34.77,76.37c0-1.01-.35-1.69-1.21-1.69-.39,0-.78.21-1.22.63v2.41c.42.35.81.47,1.12.47.76,0,1.32-.68,1.32-1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.39,77.54c0-1.02.85-1.52,2.82-1.73,0-.58-.2-1.14-.95-1.14-.53,0-1.01.24-1.37.47l-.3-.53c.43-.28,1.07-.6,1.81-.6,1.12,0,1.6.75,1.6,1.89v2.83h-.64l-.08-.55h-.03c-.44.37-.94.66-1.52.66-.77,0-1.35-.47-1.35-1.31ZM39.22,77.62v-1.25c-1.55.18-2.06.53-2.06,1.13,0,.51.35.71.8.71s.81-.2,1.26-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.33,72.67c0-.3.22-.51.52-.51s.52.21.52.51-.22.51-.52.51-.52-.2-.52-.51ZM41.46,74.13h.79v4.6h-.79v-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8,74.13h.64l.07.66h.03c.44-.44.91-.78,1.54-.78.98,0,1.41.63,1.41,1.8v2.92h-.79v-2.81c0-.86-.27-1.22-.87-1.22-.46,0-.8.24-1.25.7v3.34h-.79v-4.6Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gtext7",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.29,87.21c0-2,1.18-3.22,2.76-3.22.76,0,1.35.36,1.72.77l-.44.49c-.33-.34-.74-.56-1.27-.56-1.17,0-1.94.96-1.94,2.5s.74,2.54,1.91,2.54c.6,0,1.04-.24,1.44-.67l.44.47c-.5.58-1.11.9-1.9.9-1.55,0-2.71-1.19-2.71-3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5,89.9l2.42-3.55h-2.15v-.63h3.15v.42l-2.42,3.54h2.5v.64h-3.5v-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.58,88.02c0-1.5,1.01-2.42,2.07-2.42,1.18,0,1.85.83,1.85,2.16,0,.17,0,.31-.04.46h-3.1c.07.95.64,1.57,1.52,1.57.45,0,.83-.12,1.16-.34l.27.5c-.4.28-.89.47-1.53.47-1.23,0-2.2-.89-2.2-2.42ZM30.79,87.62c0-.91-.43-1.39-1.13-1.39-.64,0-1.21.51-1.31,1.39h2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.28,88.03c0-1.54,1.03-2.43,2.22-2.43.61,0,1.02.24,1.35.54l-.39.49c-.26-.24-.55-.38-.92-.38-.83,0-1.44.71-1.44,1.77s.57,1.75,1.41,1.75c.43,0,.81-.19,1.08-.44l.34.5c-.42.38-.94.59-1.49.59-1.22,0-2.16-.88-2.16-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.94,83.57h.79v1.84l-.03.95c.43-.42.89-.76,1.53-.76.98,0,1.41.63,1.41,1.8v2.92h-.79v-2.81c0-.86-.27-1.22-.87-1.22-.46,0-.8.24-1.25.7v3.34h-.79v-6.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.97,84.26c0-.3.22-.51.52-.51s.52.21.52.51-.22.51-.52.51-.52-.2-.52-.51ZM42.1,85.72h.79v4.6h-.79v-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.15,89.13c0-1.02.85-1.52,2.82-1.73,0-.58-.2-1.14-.95-1.14-.53,0-1.01.24-1.37.47l-.3-.53c.43-.28,1.07-.6,1.81-.6,1.12,0,1.6.75,1.6,1.89v2.83h-.64l-.08-.55h-.03c-.44.37-.94.66-1.52.66-.77,0-1.35-.47-1.35-1.31ZM46.98,89.2v-1.25c-1.55.18-2.06.53-2.06,1.13,0,.51.35.71.8.71s.81-.2,1.26-.59Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gtext8",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.89,95.69h.91l2.09,6.22h-.84l-.59-1.89h-2.26l-.6,1.89h-.81l2.09-6.22ZM22.41,99.37h1.86l-.29-.94c-.23-.69-.43-1.37-.63-2.09h-.04c-.19.72-.39,1.4-.61,2.09l-.29.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.58,100.22v-2.92h.79v2.81c0,.85.27,1.22.87,1.22.46,0,.8-.24,1.22-.78v-3.26h.79v4.6h-.64l-.07-.72h-.03c-.43.5-.88.83-1.52.83-.98,0-1.41-.62-1.41-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.29,101.35l.36-.46c.4.33.81.5,1.38.5.61,0,.9-.31.9-.71,0-.47-.51-.67-1.03-.86-.69-.25-1.35-.58-1.35-1.34s.59-1.31,1.59-1.31c.58,0,1.07.22,1.43.52l-.36.46c-.32-.24-.65-.37-1.06-.37-.59,0-.84.32-.84.66,0,.42.4.59.98.79.72.26,1.41.57,1.41,1.4,0,.75-.6,1.37-1.69,1.37-.67,0-1.29-.25-1.72-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.72,100.47v-2.54h-.68v-.59l.72-.05.09-1.48h.65v1.48h1.25v.63h-1.25v2.56c0,.56.19.88.71.88.17,0,.34-.03.53-.11l.16.56c-.25.11-.56.2-.87.2-.99,0-1.32-.62-1.32-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8,97.3h.64l.07.83h.03c.32-.58.8-.95,1.31-.95.21,0,.35.03.49.09l-.17.67c-.13-.04-.24-.06-.42-.06-.39,0-.85.27-1.17,1.05v2.96h-.79v-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.97,95.84c0-.3.22-.51.52-.51s.52.21.52.51-.22.51-.52.51-.52-.2-.52-.51ZM42.09,97.3h.79v4.6h-.79v-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.15,100.71c0-1.02.85-1.52,2.82-1.73,0-.58-.2-1.14-.95-1.14-.53,0-1.01.24-1.37.47l-.3-.53c.43-.28,1.07-.6,1.81-.6,1.12,0,1.6.75,1.6,1.89v2.83h-.64l-.08-.55h-.03c-.44.37-.94.66-1.52.66-.77,0-1.35-.47-1.35-1.31ZM46.97,100.78v-1.25c-1.55.18-2.06.53-2.06,1.13,0,.51.35.71.8.71s.81-.2,1.26-.59Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gtext9",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.43,112.67l.45-.52c.46.46,1.09.75,1.74.75.81,0,1.3-.41,1.3-1,0-.63-.46-.83-1.03-1.09l-.9-.4c-.58-.25-1.25-.68-1.25-1.6s.82-1.65,1.95-1.65c.76,0,1.4.31,1.84.75l-.44.53c-.38-.36-.86-.58-1.4-.58-.69,0-1.15.35-1.15.9,0,.6.54.82,1.02,1.02l.89.39c.72.3,1.28.74,1.28,1.66,0,.99-.81,1.77-2.12,1.77-.89,0-1.64-.35-2.18-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.87,112.56v-5.82h.79v5.88c0,.25.1.33.23.33.05,0,.08,0,.16-.02l.1.59c-.11.06-.26.08-.45.08-.59,0-.82-.38-.82-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.94,111.19c0-1.54,1-2.43,2.13-2.43s2.14.88,2.14,2.43-1.01,2.41-2.14,2.41-2.13-.88-2.13-2.41ZM26.4,111.19c0-1.06-.53-1.77-1.33-1.77s-1.32.71-1.32,1.77.53,1.75,1.32,1.75,1.33-.7,1.33-1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.72,108.88h.81l.86,2.61c.14.45.28.92.43,1.36h.04c.13-.45.28-.91.43-1.36l.86-2.61h.78l-1.63,4.61h-.92l-1.66-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.34,112.29c0-1.02.85-1.52,2.82-1.73,0-.58-.2-1.14-.95-1.14-.53,0-1.01.24-1.37.47l-.3-.53c.43-.28,1.07-.6,1.81-.6,1.12,0,1.6.75,1.6,1.89v2.83h-.64l-.08-.55h-.03c-.44.37-.94.66-1.52.66-.77,0-1.35-.47-1.35-1.31ZM35.17,112.37v-1.25c-1.55.18-2.06.53-2.06,1.13,0,.51.35.71.8.71s.81-.2,1.26-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.41,106.74h.78v4.55h.03l1.94-2.41h.88l-1.54,1.86,1.73,2.75h-.85l-1.35-2.21-.85,1v1.21h-.78v-6.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.97,107.42c0-.3.22-.51.52-.51s.52.21.52.51-.22.51-.52.51-.52-.2-.52-.51ZM42.1,108.88h.79v4.61h-.79v-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.15,112.29c0-1.02.85-1.52,2.82-1.73,0-.58-.2-1.14-.95-1.14-.53,0-1.01.24-1.37.47l-.3-.53c.43-.28,1.07-.6,1.81-.6,1.12,0,1.6.75,1.6,1.89v2.83h-.64l-.08-.55h-.03c-.44.37-.94.66-1.52.66-.77,0-1.35-.47-1.35-1.31ZM46.98,112.37v-1.25c-1.55.18-2.06.53-2.06,1.13,0,.51.35.71.8.71s.81-.2,1.26-.59Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gtext10",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.66,122.5v-3.65h.8v3.67c0,1.49.63,1.96,1.44,1.96s1.47-.47,1.47-1.96v-3.67h.77v3.65c0,1.99-.97,2.68-2.24,2.68s-2.24-.69-2.24-2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.74,118.32h.78v4.55h.03l1.94-2.41h.88l-1.54,1.86,1.73,2.75h-.85l-1.35-2.21-.85,1v1.21h-.78v-6.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.43,120.46h.64l.07.83h.03c.32-.58.8-.95,1.31-.95.21,0,.35.03.49.09l-.17.67c-.13-.04-.24-.06-.42-.06-.39,0-.85.27-1.17,1.05v2.96h-.79v-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.21,123.88c0-1.02.85-1.52,2.82-1.73,0-.58-.2-1.14-.95-1.14-.53,0-1.01.24-1.37.47l-.3-.53c.43-.28,1.07-.6,1.81-.6,1.12,0,1.6.75,1.6,1.89v2.83h-.64l-.08-.55h-.03c-.44.37-.94.66-1.52.66-.77,0-1.35-.47-1.35-1.31ZM34.04,123.95v-1.25c-1.55.18-2.06.53-2.06,1.13,0,.51.35.71.8.71s.81-.2,1.26-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.15,119.01c0-.3.22-.51.52-.51s.52.21.52.51-.22.51-.52.51-.52-.2-.52-.51ZM36.27,120.46h.79v4.61h-.79v-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.62,120.46h.64l.07.66h.03c.44-.44.91-.78,1.54-.78.98,0,1.41.62,1.41,1.8v2.92h-.79v-2.81c0-.86-.27-1.22-.87-1.22-.46,0-.8.24-1.25.7v3.34h-.79v-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.46,122.77c0-1.5,1.01-2.42,2.07-2.42,1.18,0,1.85.83,1.85,2.16,0,.17,0,.31-.04.46h-3.1c.07.95.64,1.57,1.52,1.57.45,0,.83-.12,1.16-.34l.27.5c-.4.28-.89.47-1.53.47-1.23,0-2.2-.89-2.2-2.42ZM46.67,122.37c0-.91-.43-1.39-1.13-1.39-.64,0-1.21.51-1.31,1.39h2.44Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gtext11",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.41,130.44h.8v2.6h2.88v-2.6h.8v6.22h-.8v-2.92h-2.88v2.92h-.8v-6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.45,134.97v-2.92h.79v2.81c0,.85.27,1.22.87,1.22.46,0,.8-.24,1.22-.78v-3.26h.79v4.61h-.64l-.07-.72h-.03c-.43.5-.88.83-1.52.83-.98,0-1.41-.62-1.41-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.67,132.05h.64l.07.66h.03c.44-.44.91-.78,1.54-.78.98,0,1.41.62,1.41,1.8v2.92h-.79v-2.81c0-.86-.27-1.22-.87-1.22-.46,0-.8.24-1.25.7v3.33h-.79v-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5,137.53c0-.39.26-.76.67-1.04v-.04c-.23-.14-.41-.39-.41-.75,0-.39.27-.69.5-.85v-.04c-.3-.25-.6-.69-.6-1.24,0-1,.8-1.64,1.73-1.64.26,0,.48.05.65.11h1.6v.61h-.94c.22.21.37.55.37.94,0,.99-.75,1.6-1.69,1.6-.23,0-.47-.06-.68-.16-.17.14-.29.29-.29.55,0,.28.19.49.81.49h.89c1.07,0,1.61.34,1.61,1.1,0,.86-.9,1.6-2.33,1.6-1.13,0-1.9-.45-1.9-1.24ZM33.97,137.3c0-.43-.32-.57-.93-.57h-.79c-.18,0-.4-.02-.6-.08-.33.24-.47.51-.47.78,0,.49.5.8,1.34.8s1.45-.46,1.45-.93ZM33.39,133.57c0-.66-.44-1.07-.98-1.07s-.98.4-.98,1.07.45,1.09.98,1.09.98-.42.98-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.21,135.46c0-1.02.85-1.52,2.82-1.73,0-.58-.2-1.14-.95-1.14-.53,0-1.01.24-1.37.47l-.3-.53c.43-.28,1.07-.6,1.81-.6,1.12,0,1.6.75,1.6,1.89v2.83h-.64l-.08-.55h-.03c-.44.37-.94.66-1.52.66-.77,0-1.35-.47-1.35-1.31ZM38.03,135.54v-1.25c-1.55.18-2.06.53-2.06,1.13,0,.51.35.71.8.71s.81-.2,1.26-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.27,132.05h.64l.07.83h.03c.32-.58.8-.95,1.31-.95.21,0,.35.03.49.09l-.17.67c-.13-.04-.24-.06-.42-.06-.39,0-.85.27-1.17,1.05v2.96h-.79v-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.34,138.54l.17-.62c.11.04.23.06.34.06.51,0,.84-.41,1.03-.98l.1-.34-1.85-4.62h.81l.93,2.54c.15.4.3.87.45,1.3h.04c.12-.42.26-.89.38-1.3l.82-2.54h.77l-1.73,4.98c-.32.91-.81,1.6-1.72,1.6-.22,0-.4-.04-.55-.09Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gtext12",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.86,147.42l.45-.52c.46.46,1.09.75,1.74.75.81,0,1.3-.41,1.3-1,0-.63-.46-.83-1.03-1.09l-.9-.4c-.58-.25-1.25-.68-1.25-1.6s.82-1.65,1.95-1.65c.76,0,1.4.31,1.84.75l-.44.53c-.38-.36-.86-.58-1.4-.58-.69,0-1.15.35-1.15.9,0,.6.54.82,1.02,1.02l.89.39c.72.3,1.28.74,1.28,1.66,0,.99-.81,1.77-2.12,1.77-.89,0-1.64-.35-2.18-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3,147.31v-5.82h.79v5.88c0,.25.1.33.23.33.05,0,.08,0,.16-.02l.1.59c-.11.06-.26.08-.45.08-.59,0-.82-.38-.82-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.37,145.94c0-1.54,1-2.43,2.13-2.43s2.14.88,2.14,2.43-1.01,2.41-2.14,2.41-2.13-.88-2.13-2.41ZM25.83,145.94c0-1.06-.53-1.77-1.33-1.77s-1.32.71-1.32,1.77.53,1.75,1.32,1.75,1.33-.7,1.33-1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.15,143.63h.81l.86,2.61c.14.45.28.92.43,1.36h.04c.13-.45.28-.91.43-1.36l.86-2.61h.78l-1.63,4.61h-.92l-1.66-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.87,145.93c0-1.5,1.01-2.42,2.07-2.42,1.18,0,1.85.83,1.85,2.16,0,.17,0,.31-.04.46h-3.1c.07.95.64,1.57,1.52,1.57.45,0,.83-.12,1.16-.34l.27.5c-.4.28-.89.47-1.53.47-1.23,0-2.2-.89-2.2-2.42ZM35.08,145.54c0-.91-.43-1.39-1.13-1.39-.64,0-1.21.51-1.31,1.39h2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.91,143.63h.64l.07.66h.03c.44-.44.91-.78,1.54-.78.98,0,1.41.62,1.41,1.8v2.92h-.79v-2.81c0-.86-.27-1.22-.87-1.22-.46,0-.8.24-1.25.7v3.34h-.79v-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.97,142.17c0-.3.22-.51.52-.51s.52.21.52.51-.22.51-.52.51-.52-.2-.52-.51ZM42.1,143.63h.79v4.61h-.79v-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.15,147.04c0-1.02.85-1.52,2.82-1.73,0-.58-.2-1.14-.95-1.14-.53,0-1.01.24-1.37.47l-.3-.53c.43-.28,1.07-.6,1.81-.6,1.12,0,1.6.75,1.6,1.89v2.83h-.64l-.08-.55h-.03c-.44.37-.94.66-1.52.66-.77,0-1.35-.47-1.35-1.31ZM46.98,147.12v-1.25c-1.55.18-2.06.53-2.06,1.13,0,.51.35.71.8.71s.81-.2,1.26-.59Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gtext13",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.35,153.6h1.85c1.26,0,2.14.43,2.14,1.52,0,.62-.33,1.17-.91,1.36v.04c.74.14,1.26.63,1.26,1.49,0,1.22-.97,1.82-2.35,1.82h-1.99v-6.22ZM18.07,156.25c1.05,0,1.49-.39,1.49-1.02,0-.72-.49-.99-1.46-.99h-.95v2.01h.92ZM18.23,159.19c1.06,0,1.68-.38,1.68-1.21,0-.77-.6-1.12-1.68-1.12h-1.08v2.33h1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.51,157.52c0-1.5,1.01-2.42,2.07-2.42,1.18,0,1.85.83,1.85,2.16,0,.17,0,.31-.04.46h-3.1c.07.95.64,1.57,1.52,1.57.45,0,.83-.12,1.16-.34l.27.5c-.4.28-.89.47-1.53.47-1.23,0-2.2-.89-2.2-2.42ZM24.72,157.12c0-.91-.43-1.39-1.13-1.39-.64,0-1.21.51-1.31,1.39h2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.55,158.89v-5.82h.79v5.88c0,.25.1.33.23.33.05,0,.08,0,.16-.02l.1.59c-.11.06-.26.08-.45.08-.59,0-.82-.38-.82-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.62,160.7c0-.39.26-.76.67-1.04v-.04c-.23-.14-.41-.39-.41-.75,0-.39.27-.69.5-.85v-.04c-.3-.25-.6-.69-.6-1.24,0-1,.8-1.64,1.73-1.64.26,0,.48.05.65.11h1.6v.61h-.94c.22.21.37.55.37.94,0,.99-.75,1.6-1.69,1.6-.23,0-.47-.06-.68-.16-.17.14-.29.29-.29.55,0,.28.19.49.81.49h.89c1.07,0,1.61.34,1.61,1.1,0,.86-.9,1.6-2.33,1.6-1.13,0-1.9-.45-1.9-1.24ZM32.09,160.46c0-.43-.32-.57-.93-.57h-.79c-.18,0-.4-.02-.6-.08-.33.24-.47.51-.47.78,0,.49.5.8,1.34.8s1.45-.46,1.45-.93ZM31.5,156.74c0-.66-.44-1.07-.98-1.07s-.98.4-.98,1.07.45,1.09.98,1.09.98-.42.98-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.63,153.76c0-.3.22-.51.52-.51s.52.21.52.51-.22.51-.52.51-.52-.2-.52-.51ZM33.75,155.21h.79v4.61h-.79v-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.03,158.13v-2.92h.79v2.81c0,.85.27,1.22.87,1.22.46,0,.8-.24,1.22-.78v-3.26h.79v4.61h-.64l-.07-.72h-.03c-.43.5-.88.83-1.52.83-.98,0-1.41-.62-1.41-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.25,155.21h.64l.07.66h.03c.41-.44.88-.78,1.43-.78.71,0,1.09.33,1.28.87.47-.51.96-.87,1.52-.87.95,0,1.4.62,1.4,1.8v2.92h-.79v-2.81c0-.86-.27-1.22-.85-1.22-.36,0-.73.23-1.16.7v3.34h-.79v-2.81c0-.86-.27-1.22-.85-1.22-.34,0-.72.23-1.15.7v3.34h-.79v-4.61Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gtext14",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4,170.59l.45-.52c.46.46,1.09.75,1.74.75.81,0,1.3-.41,1.3-1,0-.63-.46-.83-1.03-1.09l-.9-.4c-.58-.25-1.25-.68-1.25-1.6s.82-1.65,1.95-1.65c.76,0,1.4.31,1.84.75l-.44.53c-.38-.36-.86-.58-1.4-.58-.69,0-1.15.35-1.15.9,0,.6.54.82,1.02,1.02l.89.39c.72.3,1.28.74,1.28,1.66,0,.99-.81,1.77-2.12,1.77-.89,0-1.64-.35-2.18-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5,169.1c0-1.5,1.01-2.42,2.07-2.42,1.18,0,1.85.83,1.85,2.16,0,.17,0,.31-.04.46h-3.1c.07.95.64,1.57,1.52,1.57.45,0,.83-.12,1.16-.34l.27.5c-.4.28-.89.47-1.53.47-1.23,0-2.2-.89-2.2-2.42ZM31.72,168.7c0-.91-.43-1.39-1.13-1.39-.64,0-1.21.51-1.31,1.39h2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.54,166.8h.64l.07.83h.03c.32-.58.8-.95,1.31-.95.21,0,.35.03.49.09l-.17.67c-.13-.04-.24-.06-.42-.06-.39,0-.85.27-1.17,1.05v2.96h-.79v-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.57,170.93h-.03l-.08.47h-.63v-6.75h.79v1.84l-.03.82c.43-.36.94-.63,1.45-.63,1.18,0,1.83.92,1.83,2.34,0,1.57-.95,2.49-2,2.49-.43,0-.9-.22-1.31-.59ZM40.06,169.03c0-1.01-.35-1.69-1.21-1.69-.39,0-.79.21-1.22.62v2.41c.4.35.81.47,1.12.47.76,0,1.32-.68,1.32-1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.97,165.34c0-.3.22-.51.52-.51s.52.21.52.51-.22.51-.52.51-.52-.2-.52-.51ZM42.09,166.8h.79v4.61h-.79v-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.15,170.21c0-1.02.85-1.52,2.82-1.73,0-.58-.2-1.14-.95-1.14-.53,0-1.01.24-1.37.47l-.3-.53c.43-.28,1.07-.6,1.81-.6,1.12,0,1.6.75,1.6,1.89v2.83h-.64l-.08-.55h-.03c-.44.37-.94.66-1.52.66-.77,0-1.35-.47-1.35-1.31ZM46.97,170.29v-1.25c-1.55.18-2.06.53-2.06,1.13,0,.51.35.71.8.71s.81-.2,1.26-.59Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gtext15",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.32,176.77h1.85c1.26,0,2.14.43,2.14,1.52,0,.62-.33,1.17-.91,1.36v.04c.74.14,1.26.63,1.26,1.49,0,1.22-.97,1.82-2.35,1.82h-1.99v-6.22ZM18.03,179.41c1.05,0,1.49-.39,1.49-1.02,0-.72-.49-.99-1.46-.99h-.95v2.01h.92ZM18.19,182.35c1.06,0,1.68-.38,1.68-1.21,0-.77-.6-1.12-1.68-1.12h-1.08v2.33h1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75,181.3v-2.92h.79v2.81c0,.85.27,1.22.87,1.22.46,0,.8-.24,1.22-.78v-3.26h.79v4.61h-.64l-.07-.72h-.03c-.43.5-.88.83-1.52.83-.98,0-1.41-.62-1.41-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.97,182.06v-5.82h.79v5.88c0,.25.1.33.23.33.05,0,.08,0,.16-.02l.1.59c-.11.06-.26.08-.45.08-.59,0-.82-.38-.82-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.04,183.87c0-.39.26-.76.67-1.04v-.04c-.23-.14-.41-.39-.41-.75,0-.39.27-.69.5-.85v-.04c-.3-.25-.6-.69-.6-1.24,0-1,.8-1.64,1.73-1.64.26,0,.48.05.65.11h1.6v.61h-.94c.22.21.37.55.37.94,0,.99-.75,1.6-1.69,1.6-.23,0-.47-.06-.68-.16-.17.14-.29.29-.29.55,0,.28.19.49.81.49h.89c1.07,0,1.61.34,1.61,1.1,0,.86-.9,1.6-2.33,1.6-1.13,0-1.9-.45-1.9-1.24ZM32.51,183.63c0-.43-.32-.57-.93-.57h-.79c-.18,0-.4-.02-.6-.08-.33.24-.47.51-.47.78,0,.49.5.8,1.34.8s1.45-.46,1.45-.93ZM31.92,179.91c0-.66-.44-1.07-.98-1.07s-.98.4-.98,1.07.45,1.09.98,1.09.98-.42.98-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.74,181.79c0-1.02.85-1.52,2.82-1.73,0-.58-.2-1.14-.95-1.14-.53,0-1.01.24-1.37.47l-.3-.53c.43-.28,1.07-.6,1.81-.6,1.12,0,1.6.75,1.6,1.89v2.83h-.64l-.08-.55h-.03c-.44.37-.94.66-1.52.66-.77,0-1.35-.47-1.35-1.31ZM36.56,181.87v-1.25c-1.55.18-2.06.53-2.06,1.13,0,.51.35.71.8.71s.81-.2,1.26-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8,178.38h.64l.07.83h.03c.32-.58.8-.95,1.31-.95.21,0,.35.03.49.09l-.17.67c-.13-.04-.24-.06-.42-.06-.39,0-.85.27-1.17,1.05v2.96h-.79v-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.97,176.92c0-.3.22-.51.52-.51s.52.21.52.51-.22.51-.52.51-.52-.2-.52-.51ZM42.1,178.38h.79v4.61h-.79v-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.15,181.79c0-1.02.85-1.52,2.82-1.73,0-.58-.2-1.14-.95-1.14-.53,0-1.01.24-1.37.47l-.3-.53c.43-.28,1.07-.6,1.81-.6,1.12,0,1.6.75,1.6,1.89v2.83h-.64l-.08-.55h-.03c-.44.37-.94.66-1.52.66-.77,0-1.35-.47-1.35-1.31ZM46.98,181.87v-1.25c-1.55.18-2.06.53-2.06,1.13,0,.51.35.71.8.71s.81-.2,1.26-.59Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gtext16",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.93,193.75l.45-.52c.46.46,1.09.75,1.74.75.81,0,1.3-.41,1.3-1,0-.63-.46-.83-1.03-1.09l-.9-.4c-.58-.25-1.25-.68-1.25-1.6s.82-1.65,1.95-1.65c.76,0,1.4.31,1.84.75l-.44.53c-.38-.36-.86-.58-1.4-.58-.69,0-1.15.35-1.15.9,0,.6.54.82,1.02,1.02l.89.39c.72.3,1.28.74,1.28,1.66,0,.99-.81,1.77-2.12,1.77-.89,0-1.64-.35-2.18-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.82,189.96h.81l.67,2.67c.1.42.2.81.27,1.31h.04c.09-.49.18-.89.28-1.31l.69-2.67h.84l.7,2.67c.1.42.21.81.3,1.31h.04c.09-.49.17-.89.27-1.31l.67-2.67h.75l-1.24,4.61h-1l-.63-2.47c-.11-.43-.2-.82-.3-1.36h-.04c-.09.54-.17.95-.29,1.36l-.62,2.47h-.95l-1.29-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8,192.27c0-1.5,1.01-2.42,2.07-2.42,1.18,0,1.85.83,1.85,2.16,0,.17,0,.31-.04.46h-3.1c.07.95.64,1.57,1.52,1.57.45,0,.83-.12,1.16-.34l.27.5c-.4.28-.89.47-1.53.47-1.23,0-2.2-.89-2.2-2.42ZM32.01,191.87c0-.91-.43-1.39-1.13-1.39-.64,0-1.21.51-1.31,1.39h2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.51,192.28c0-1.5.95-2.43,2-2.43.53,0,.88.2,1.29.53l-.04-.79v-1.77h.79v6.75h-.64l-.07-.54h-.03c-.36.35-.85.65-1.39.65-1.16,0-1.9-.87-1.9-2.41ZM36.76,193.39v-2.41c-.39-.35-.74-.47-1.12-.47-.73,0-1.32.7-1.32,1.75s.46,1.75,1.26,1.75c.43,0,.8-.21,1.17-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.76,192.27c0-1.5,1.01-2.42,2.07-2.42,1.18,0,1.85.83,1.85,2.16,0,.17,0,.31-.04.46h-3.1c.07.95.64,1.57,1.52,1.57.45,0,.83-.12,1.16-.34l.27.5c-.4.28-.89.47-1.53.47-1.23,0-2.2-.89-2.2-2.42ZM41.97,191.87c0-.91-.43-1.39-1.13-1.39-.64,0-1.21.51-1.31,1.39h2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8,189.96h.64l.07.66h.03c.44-.44.91-.78,1.54-.78.98,0,1.41.62,1.41,1.8v2.92h-.79v-2.81c0-.86-.27-1.22-.87-1.22-.46,0-.8.24-1.25.7v3.33h-.79v-4.61Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gtext17",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.42,199.94h.85l2.22,3.88c.24.42.46.88.67,1.34h.04c-.05-.64-.1-1.33-.1-1.97v-3.24h.75v6.22h-.85l-2.22-3.88c-.24-.42-.46-.88-.67-1.34h-.04c.05.63.1,1.3.1,1.94v3.27H.42v-6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13,203.85c0-1.5,1.01-2.42,2.07-2.42,1.18,0,1.85.83,1.85,2.16,0,.17,0,.31-.04.46h-3.1c.07.95.64,1.57,1.52,1.57.45,0,.83-.12,1.16-.34l.27.5c-.4.28-.89.47-1.53.47-1.23,0-2.2-.89-2.2-2.42ZM9.34,203.45c0-.91-.43-1.39-1.13-1.39-.64,0-1.21.51-1.31,1.39h2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.21,204.72v-2.54h-.68v-.59l.72-.05.09-1.48h.65v1.48h1.25v.63h-1.25v2.56c0,.56.19.88.71.88.17,0,.34-.03.53-.11l.16.56c-.25.11-.56.2-.87.2-.99,0-1.32-.62-1.32-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.29,199.41h.79v1.84l-.03.95c.43-.42.89-.76,1.53-.76.98,0,1.41.62,1.41,1.8v2.92h-.79v-2.81c0-.86-.27-1.22-.87-1.22-.46,0-.8.24-1.25.7v3.33h-.79v-6.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1,203.85c0-1.5,1.01-2.42,2.07-2.42,1.18,0,1.85.83,1.85,2.16,0,.17,0,.31-.04.46h-3.1c.07.95.64,1.57,1.52,1.57.45,0,.83-.12,1.16-.34l.27.5c-.4.28-.89.47-1.53.47-1.23,0-2.2-.89-2.2-2.42ZM22.31,203.45c0-.91-.43-1.39-1.13-1.39-.64,0-1.21.51-1.31,1.39h2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.14,201.55h.64l.07.83h.03c.32-.58.8-.95,1.31-.95.21,0,.35.03.49.09l-.17.67c-.13-.04-.24-.06-.42-.06-.39,0-.85.27-1.17,1.05v2.96h-.79v-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.44,205.22v-5.82h.79v5.88c0,.25.1.33.23.33.05,0,.08,0,.16-.02l.1.59c-.11.06-.26.08-.45.08-.59,0-.82-.38-.82-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.57,204.96c0-1.02.85-1.52,2.82-1.73,0-.58-.2-1.14-.95-1.14-.53,0-1.01.24-1.37.47l-.3-.53c.43-.28,1.07-.6,1.81-.6,1.12,0,1.6.75,1.6,1.89v2.83h-.64l-.08-.55h-.03c-.44.37-.94.66-1.52.66-.77,0-1.35-.47-1.35-1.31ZM32.4,205.04v-1.25c-1.55.18-2.06.53-2.06,1.13,0,.51.35.71.8.71s.81-.2,1.26-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.64,201.55h.64l.07.66h.03c.44-.44.91-.78,1.54-.78.98,0,1.41.62,1.41,1.8v2.92h-.79v-2.81c0-.86-.27-1.22-.87-1.22-.46,0-.8.24-1.25.7v3.33h-.79v-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.49,203.86c0-1.5.95-2.43,2-2.43.53,0,.88.2,1.29.53l-.04-.79v-1.77h.79v6.75h-.64l-.07-.54h-.03c-.36.35-.85.65-1.39.65-1.16,0-1.9-.87-1.9-2.41ZM42.74,204.98v-2.41c-.39-.35-.74-.47-1.12-.47-.73,0-1.32.7-1.32,1.75s.46,1.75,1.26,1.75c.43,0,.8-.21,1.17-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.57,205.6l.36-.46c.4.33.81.5,1.38.5.61,0,.9-.31.9-.71,0-.47-.51-.67-1.03-.86-.69-.25-1.35-.58-1.35-1.34s.59-1.31,1.59-1.31c.58,0,1.07.22,1.43.52l-.36.45c-.32-.24-.65-.37-1.06-.37-.59,0-.84.32-.84.66,0,.42.4.59.98.79.72.26,1.41.57,1.41,1.4,0,.75-.6,1.37-1.69,1.37-.67,0-1.29-.25-1.72-.66Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gtext18",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.08,215.17v-3.65h.8v3.67c0,1.49.63,1.96,1.44,1.96s1.47-.47,1.47-1.96v-3.67h.77v3.65c0,1.99-.97,2.68-2.24,2.68s-2.24-.69-2.24-2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.23,211.52h.8v3.11h.03l2.57-3.11h.91l-1.95,2.37,2.25,3.85h-.89l-1.85-3.22-1.06,1.26v1.96h-.8v-6.22Z"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "gtext19",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M55.06,8.05h1.31v-3.36h-1.13v-.91c.65-.12,1.09-.28,1.52-.56h1.08v4.83h1.12v1.18h-3.89v-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M59.85,8.61l.78-.87c.2.23.58.43.92.43.65,0,1.15-.45,1.2-1.8-.31.4-.82.63-1.17.63-1.03,0-1.81-.58-1.81-1.86s.93-2.03,2.03-2.03c1.17,0,2.3.86,2.3,2.99s-1.17,3.25-2.44,3.25c-.81,0-1.41-.34-1.8-.74ZM61.86,5.96c.3,0,.63-.16.86-.56-.13-.93-.51-1.19-.89-1.19s-.72.27-.72.93c0,.62.32.82.75.82Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gtext20",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M55.06,19.64h1.31v-3.36h-1.13v-.91c.65-.12,1.09-.28,1.52-.56h1.08v4.83h1.12v1.18h-3.89v-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M59.85,20.2l.78-.87c.2.23.58.43.92.43.65,0,1.15-.45,1.2-1.8-.31.4-.82.63-1.17.63-1.03,0-1.81-.58-1.81-1.86s.93-2.03,2.03-2.03c1.17,0,2.3.86,2.3,2.99s-1.17,3.25-2.44,3.25c-.81,0-1.41-.34-1.8-.74ZM61.86,17.54c.3,0,.63-.16.86-.56-.13-.93-.51-1.19-.89-1.19s-.72.27-.72.93c0,.62.32.82.75.82Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gtext21",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M55.06,31.22h1.31v-3.36h-1.13v-.91c.65-.12,1.09-.28,1.52-.56h1.08v4.83h1.12v1.18h-3.89v-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M59.83,29.52c0-2.23,1.18-3.25,2.44-3.25.81,0,1.41.35,1.8.74l-.78.87c-.2-.22-.58-.43-.92-.43-.64,0-1.15.45-1.2,1.8.31-.4.82-.63,1.18-.63,1.02,0,1.8.58,1.8,1.86s-.93,2.03-2.03,2.03c-1.17,0-2.3-.86-2.3-2.99ZM61.22,30.23c.12.92.5,1.18.88,1.18s.73-.27.73-.93c0-.62-.33-.82-.76-.82-.3,0-.63.17-.85.57Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gtext22",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M55.06,42.8h1.31v-3.36h-1.13v-.91c.65-.12,1.09-.28,1.52-.56h1.08v4.83h1.12v1.18h-3.89v-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M62.23,42.58h-2.59v-1.02l2.14-3.59h1.81v3.5h.68v1.12h-.68v1.4h-1.36v-1.4ZM62.23,41.47v-.89c0-.39.03-.98.05-1.37h-.04c-.15.35-.32.69-.49,1.04l-.71,1.22h1.19Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gtext23",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M55.06,54.39h1.31v-3.36h-1.13v-.91c.65-.12,1.09-.28,1.52-.56h1.08v4.83h1.12v1.18h-3.89v-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M59.81,54.67c1.48-1.31,2.58-2.38,2.58-3.21,0-.57-.31-.86-.81-.86-.42,0-.75.28-1.04.6l-.76-.76c.59-.66,1.15-1,2-1,1.19,0,2.02.77,2.02,1.92,0,1.08-.99,2.06-2,3.04.31-.03.73-.07,1-.07h1.29v1.23h-4.27v-.9Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "gtext24",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M59.85,66.53l.78-.87c.2.23.58.43.92.43.65,0,1.15-.45,1.2-1.8-.31.4-.82.63-1.17.63-1.03,0-1.81-.58-1.81-1.86s.93-2.03,2.03-2.03c1.17,0,2.3.86,2.3,2.99s-1.17,3.25-2.44,3.25c-.81,0-1.41-.34-1.8-.74ZM61.86,63.87c.3,0,.63-.16.86-.56-.13-.93-.51-1.19-.89-1.19s-.72.27-.72.93c0,.62.32.82.75.82Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "gtext25",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M59.66,78l.66-.92c.36.33.78.59,1.27.59.6,0,.98-.3.98-.89s-.38-.88-.91-.88c-.34,0-.51.08-.87.3l-.64-.42.16-3.06h3.46v1.23h-2.2l-.09,1.05c.22-.09.41-.12.63-.12,1.04,0,1.92.59,1.92,1.86,0,1.35-1.04,2.11-2.23,2.11-.99,0-1.67-.37-2.15-.85Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "gtext26",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M59.66,89.58l.66-.92c.36.33.78.59,1.27.59.6,0,.98-.3.98-.89s-.38-.88-.91-.88c-.34,0-.51.08-.87.3l-.64-.42.16-3.06h3.46v1.23h-2.2l-.09,1.05c.22-.09.41-.12.63-.12,1.04,0,1.92.59,1.92,1.86,0,1.35-1.04,2.11-2.23,2.11-.99,0-1.67-.37-2.15-.85Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "gtext27",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M62.23,100.5h-2.59v-1.02l2.14-3.59h1.81v3.5h.68v1.12h-.68v1.4h-1.36v-1.4ZM62.23,99.38v-.89c0-.39.03-.98.05-1.37h-.04c-.15.35-.32.69-.49,1.04l-.71,1.22h1.19Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "gtext28",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M59.65,112.75l.67-.93c.37.35.81.6,1.29.6.58,0,.95-.24.95-.67,0-.5-.28-.81-1.57-.81v-1.03c1.05,0,1.38-.31,1.38-.77,0-.41-.26-.62-.71-.62-.42,0-.73.18-1.1.51l-.74-.89c.56-.48,1.17-.78,1.9-.78,1.28,0,2.11.6,2.11,1.67,0,.61-.35,1.05-1,1.33v.04c.69.2,1.18.68,1.18,1.46,0,1.13-1.04,1.75-2.26,1.75-.98,0-1.67-.34-2.11-.85Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "gtext29",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M59.8,124.17c1.48-1.31,2.58-2.38,2.58-3.21,0-.57-.31-.86-.81-.86-.42,0-.75.28-1.04.6l-.76-.76c.59-.66,1.15-1,2-1,1.19,0,2.02.77,2.02,1.92,0,1.08-.99,2.06-2,3.04.31-.03.73-.07,1-.07h1.29v1.23h-4.27v-.9Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "gtext30",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M59.8,135.75c1.48-1.31,2.58-2.38,2.58-3.21,0-.57-.31-.86-.81-.86-.42,0-.75.28-1.04.6l-.76-.76c.59-.66,1.15-1,2-1,1.19,0,2.02.77,2.02,1.92,0,1.08-.99,2.06-2,3.04.31-.03.73-.07,1-.07h1.29v1.23h-4.27v-.9Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "gtext31",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M59.8,147.34c1.48-1.31,2.58-2.38,2.58-3.21,0-.57-.31-.86-.81-.86-.42,0-.75.28-1.04.6l-.76-.76c.59-.66,1.15-1,2-1,1.19,0,2.02.77,2.02,1.92,0,1.08-.99,2.06-2,3.04.31-.03.73-.07,1-.07h1.29v1.23h-4.27v-.9Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "gtext32",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M59.8,158.92c1.48-1.31,2.58-2.38,2.58-3.21,0-.57-.31-.86-.81-.86-.42,0-.75.28-1.04.6l-.76-.76c.59-.66,1.15-1,2-1,1.19,0,2.02.77,2.02,1.92,0,1.08-.99,2.06-2,3.04.31-.03.73-.07,1-.07h1.29v1.23h-4.27v-.9Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "gtext33",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M60.1,170.22h1.31v-3.36h-1.13v-.91c.65-.12,1.09-.28,1.52-.56h1.08v4.83h1.12v1.18h-3.89v-1.18Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "gtext34",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M60.1,181.8h1.31v-3.36h-1.13v-.91c.65-.12,1.09-.28,1.52-.56h1.08v4.83h1.12v1.18h-3.89v-1.18Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "gtext35",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M60.1,193.38h1.31v-3.36h-1.13v-.91c.65-.12,1.09-.28,1.52-.56h1.08v4.83h1.12v1.18h-3.89v-1.18Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "gtext36",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M60.1,204.97h1.31v-3.36h-1.13v-.91c.65-.12,1.09-.28,1.52-.56h1.08v4.83h1.12v1.18h-3.89v-1.18Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "gtext37",
    "data-name": "gtext"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M60.1,216.55h1.31v-3.36h-1.13v-.91c.65-.12,1.09-.28,1.52-.56h1.08v4.83h1.12v1.18h-3.89v-1.18Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliaMembersManufacturingSitesInEurope);
export default __webpack_public_path__ + "static/media/applia-members-manufacturing-sites-in-europe.7d27ef1af46dd5914e62d4ef26ecdef1.svg";
export { ForwardRef as ReactComponent };